// extracted by mini-css-extract-plugin
module.exports = {"page":"_5Dv-FwlJ","vertical-menu":"_5D1vhaTj"};